import React, { useEffect, useState } from "react";
import { Header } from "../components/Common/Header";
import { Title } from "../components/Common/Title";
import { ServiceCard } from "../components/Services/ServiceCard";

import BgImage from "../assets/images/Headers/Services.webp";
import Close from "../assets/icons/close.png";

export const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const organization_services = [
    {
      image: "/assets/images/Services/Org/Org_Designs_00001.png",
      title: "Leadership Coaching & Development",
      caption: `For: Corporate Leaders, Managers, and Executives

Executive Coaching: One-on-one coaching sessions for top executives to improve leadership capabilities, decision-making, communication, and strategic thinking.

Leadership Programs: Tailored programs for developing leadership skills at various levels (mid-level managers, senior leaders) to boost productivity, influence, and effectiveness.

Succession Planning Support: Helping organizations prepare the next generation of leaders with specific coaching and mentoring strategies to ensure smooth leadership transitions.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00002.png",
      title: "Team Coaching & Building",
      caption: `For: Corporate Teams, Departments, and Cross-Functional Groups

Team Coaching: Facilitating group coaching to enhance collaboration, trust, and communication within teams. Focus on resolving conflicts and improving team dynamics.

High-Performance Team Development: Helping teams align their goals, understand individual strengths, and work together efficiently to achieve high performance.

Cross-Cultural Team Coaching: Specially designed coaching for global teams to improve multicultural communication and collaboration.
`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00003.png",
      title: "Employee Engagement & Well-Being Programs",
      caption: `For: All Employees

Employee Engagement Surveys & Action Plans: Conducting surveys to assess employee satisfaction, and using the results to implement actionable strategies for improving engagement.

Wellness Programs: Designing wellness initiatives focused on mental, emotional, and physical well-being, such as stress management, work-life balance, and mindfulness.

Resilience & Burnout Prevention: Offering coaching and workshops that help employees cope with work stress, build resilience, and prevent burnout.
`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00004.png",
      title: "Change Management & Organizational Transformation",
      caption: `For: Businesses undergoing Change, Mergers, Acquisitions, or Restructuring

Change Leadership Coaching: Helping leaders effectively manage transitions during periods of change and uncertainty, guiding them on how to motivate and inspire teams during these times.

Culture Transformation: Working with HR and leadership to instill a culture of innovation, accountability, inclusiveness, and agility. This includes cultural assessments and tailored workshops.

Post-Merger Integration Coaching: Assisting organizations with leadership and team integration after a merger, ensuring alignment, cooperation, and smooth transition.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00006.png",
      title: "HR Consulting & Strategy",
      caption: `For: HR Teams and Organizational Leaders

Talent Strategy & Development: Helping organizations design strategies for talent acquisition, retention, and career development to ensure alignment with business goals.

Performance Management Systems: Creating and implementing performance evaluation systems, feedback processes, and reward structures to drive employee motivation and accountability.

Leadership Competency Mapping: Identifying the key competencies needed for each role within the organization and assessing current leadership capabilities to fill gaps.
`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00007.png",
      title: "Coaching Certification & Training Programs",
      caption: `For: Aspiring Coaches and HR Professionals

ICF-Certified Coaching Programs: Offering certification in International Coaching Federation (ICF) accredited coaching programs (Level 1 and Level 2), which helps individuals build a career as professional coaches.

Train-the-Trainer Programs: Training HR professionals and managers to become internal coaches, equipping them with coaching tools and techniques that can be used to mentor and guide others.

Leadership Development Workshops: Providing in-house training for leadership and personal growth based on global best practices.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00010.png",
      title: "Diversity, Equity, and Inclusion (DEI) Initiatives",
      caption: `For: Companies aiming to build an inclusive, diverse workplace

DEI Strategy Consulting: Creating and implementing strategies to ensure a diverse, equitable, and inclusive workplace culture.

Bias Awareness Training: Running workshops on unconscious bias, cultural competence, and inclusive leadership.

Inclusive Leadership Coaching: Supporting leaders in embracing diversity and creating a safe, inclusive, and empowering environment for all employees.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00011.png",
      title: "HR Tech Integration & Employee Development Tools",
      caption: `For: Companies looking to integrate technology with HR processes

HR Software Solutions: Consulting services to identify and implement the right HR tech solutions (HRIS, LMS, Performance Management Systems) that suit an organization’s needs.

Employee Development Platforms: Introducing learning management systems (LMS), coaching apps, and platforms for continuous development and performance tracking.

Gamification for Employee Engagement: Using gamification techniques to drive motivation, learning, and engagement, especially for remote or hybrid teams.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00012.png",
      title: "Soft Skills & Personal Development Training",
      caption: `For: Employees at all levels

Communication Skills Training: Offering workshops and coaching on effective communication, public speaking, and interpersonal skills.

Conflict Resolution: Providing training and coaching on resolving conflicts in the workplace, promoting collaboration and harmonious team dynamics.

Emotional Intelligence Development: Helping employees at all levels develop emotional intelligence for better decision-making, empathy, and team interaction.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00013.png",
      title: "Employee Outplacement Services",
      caption: `For: Employees transitioning out of the organization

Career Transition Coaching: Supporting individuals who are transitioning to new roles or careers with personalized coaching for job search strategies, interview preparation, and personal branding.

Job Market Insights & Guidance: Providing tools and resources for employees to understand the job market, identify new career opportunities, and build necessary skills.`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00014.png",
      title: "Talent Acquisition & Leadership Recruitment",
      caption: `For: Companies looking for high-quality talent

Executive Search Services: Helping businesses find top-tier talent for senior leadership positions.

Cultural Fit Assessment: Assisting HR teams in evaluating candidates for cultural fit, ensuring long-term success within the organization.

Onboarding and Employee Retention Strategies: Consulting on best practices for onboarding new hires and creating systems that increase employee retention.
`,
    },
    {
      image: "/assets/images/Services/Org/Org_Designs_00015.png",
      title: "Custom Coaching Programs for Specific Industries",
      caption: `For: Companies in specific industries like tech, healthcare, manufacturing, etc.

Industry-Specific Leadership Coaching: Tailored coaching programs designed for leaders in various industries, addressing unique challenges and needs.

Skill Development for Emerging Technologies: Offering coaching and upskilling programs in areas like AI, machine learning, digital transformation, and other tech-driven changes.`,
    },
  ];

  const handleCardClick = (service) => {
    setSelectedService(service);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedService(null);
  };

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <>
      <Header image={BgImage} title="Our Services" />
      <div
        style={{
          padding: "50px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Title
          title="Our Services"
          center={true}
          subtitle="Featured Services for Individuals"
        />
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "50px",
          }}
        >
          {[
            {
              image: "/assets/images/Services/Ind/career-coaching.png",
              title: "Career Coaching",
              caption:
                "Develop a clear career vision, navigate transitions, and build the skills and confidence to achieve your career goals.",
            },
            {
              image: "/assets/images/Services/Ind/leadership.jpg",
              title: "Leadership Coaching",
              caption:
                "Enhance your leadership skills, communication style, and ability to motivate and inspire your team.",
            },
            {
              image: "/assets/images/Services/Ind/wellness.jpeg",
              title: "Wellness Coaching",
              caption:
                "Improve your well-being, build resilience, and create a more balanced and fulfilling life.",
            },
            {
              image: "/assets/images/Services/Ind/life.jpg",
              title: "Life Coaching",
              caption:
                "Gain clarity on your life goals, overcome challenges, and unlock your full potential.",
            },
            {
              image: "/assets/images/Services/Ind/icf.webp",
              title: "ICF Coach Certification",
              caption:
                "Earn your ICF credential and embark on a rewarding career as a professional coach.",
            },
          ].map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              caption={service.caption}
            />
          ))}
        </div>
      </div>

      <div
        style={{
          padding: "50px",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Title center={true} subtitle="Featured Services for Organizations" />
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "50px",
          }}
        >
          {organization_services.map((service, index) => (
            <div
              style={{
                width: "calc(50% - 25px)",
                minWidth: "300px",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0px 4px 12px 0px #00000026",
                cursor: "pointer",
              }}
              onClick={() => handleCardClick(service)}
              data-aos="fade"
            >
              <img
                style={{
                  width: "100%",
                  aspectRatio: "3/2",
                  objectFit: "cover",
                }}
                src={service.image}
                alt={service.title}
              />
              <div
                style={{
                  padding: "20px",
                  gap: "10px",
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                  {service.title}
                </p>
                {/* <p style={{ fontSize: "16px", color: "#545454" }}>
                  {service.caption}
                </p> */}
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "8px",
              width: "80%",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              maxWidth: "800px",
              overflow: "auto",
              maxHeight: "80%",
              paddingBottom: "50px",
            }}
            data-aos="fade-up"
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ justifyContent: "flex-end", display: "flex" }}>
              <button
                onClick={closeModal}
                style={{
                  cursor: "pointer",
                  border: "none",
                  backgroundColor: "transparent",
                  top: "20px",
                  right: "20px",
                }}
              >
                <img
                  src={Close}
                  width={30}
                  height={30}
                  alt=""
                />
              </button>
            </div>
            <h2 style={{ fontSize: "20px", fontWeight: "bold" }}>
              {selectedService.title}
            </h2>
            {window.innerWidth < 550 && (
              <img
                style={{
                  width: "100%",
                  aspectRatio: "16/9",
                  objectFit: "cover",
                  // maxWidth: "300px"
                }}
                src={selectedService.image}
                alt={selectedService.title}
              />
            )}

            <p
              style={{
                fontSize: "16px",
                color: "#545454",
                marginTop: "10px",
                whiteSpace: "pre-wrap",
              }}
            >
              {selectedService.caption}
            </p>
          </div>
        </div>
      )}
    </>
  );
};